<template>
  <div class="w-full m-0 p-0">
    <div
      v-if="notas.length > 0 && fatura.id"
      :id="'notaLista' + fatura.id"
      class="vs-con-loading__container"
    >
      <span v-for="(nota, index) in notas" :key="index">
        <vs-row vs-align="center" vs-type="flex" vs-w="12">
          <vx-card
            :style="
              nota.id_status == 1 && nota.lixeira == 0 && nota.hasError == 0
                ? 'border-color:#0f4084 !important'
                : nota.id_status == 2 && nota.lixeira == 0 && nota.hasError == 0
                ? 'border-color:#00BBA2 !important'
                : 'border-color:#C0564B !important'
            "
            class="border ml-5 mb-2 p-0"
            no-shadow
          >
            <vs-list id="lista" class="my-0 p-0">
              <vs-list-item
                :style="
                  nota.id_status == 1 && nota.lixeira == 0 && nota.hasError == 0
                    ? 'color:#0f4084'
                    : nota.id_status == 2 &&
                      nota.lixeira == 0 &&
                      nota.hasError == 0
                    ? 'color:#00BBA2'
                    : 'color:#C0564B'
                "
                class="mt-0 p-0"
              >
                <template slot="avatar">
                  <div class="list-titles">
                    <div class="vs-list--icon">
                      <vs-icon class="mx-1" icon="description"></vs-icon>
                      <div
                        class="vs-list--title"
                        style="cursor: pointer"
                        @click="editarNota(nota)"
                      >
                        <vx-tooltip color="warning" text="Editar Nota">
                          {{
                            nota.hasError == 1
                              ? "Nota com Erro" +
                                (nota.lixeira > 0 ? " - Cancelada" : "")
                              : nota.numero == "SN"
                              ? "Nota S/N" +
                                (nota.lixeira > 0 ? " - Cancelada" : "")
                              : nota.id_status == 1 && nota.lixeira == 0
                              ? nota.status
                              : "Nota " +
                                (nota.numero
                                  ? " N° " + nota.numero + " - "
                                  : "") +
                                (nota.lixeira > 0 ? " Cancelada" : nota.status)
                          }}
                        </vx-tooltip>
                      </div>
                    </div>
                  </div>
                </template>
                <vs-row
                  class="mb-1"
                  vs-align="center"
                  vs-justify="space-between"
                >
                  <vx-tooltip
                    v-if="nota.hasError == 1"
                    color="danger"
                    text="Erros na Nota"
                  >
                    <vs-button
                      :disabled="
                        !$atividades.permissoes.includes(5) || blockButton
                      "
                      class="mx-1"
                      color="danger"
                      icon="warning"
                      radius
                      size="small"
                      @click="verErros(nota)"
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="nota.lixeira == 0 && nota.id_status != 3"
                    color="danger"
                    text="Cancelar Nota"
                  >
                    <el-popconfirm
                      cancelButtonText="Cancelar"
                      confirmButtonText="Confirmar"
                      icon="el-icon-circle-close"
                      iconColor="red"
                      title="Deseja cancelar esta nota?"
                      @confirm="cancelarNota(nota)"
                    >
                      <vs-button
                        slot="reference"
                        :disabled="
                          !$atividades.permissoes.includes(6) || blockButton
                        "
                        class="mx-1"
                        color="danger"
                        icon="close"
                        size="small"
                      />
                    </el-popconfirm>
                  </vx-tooltip>
                  <vx-tooltip v-else color="warning" text="Restaurar Nota">
                    <el-popconfirm
                      cancelButtonText="Cancelar"
                      confirmButtonText="Confirmar"
                      icon="el-icon-circle-close"
                      iconColor="#0f4084"
                      title="Deseja restaurar esta nota?"
                      @confirm="restaurarNota(nota)"
                    >
                      <vs-button
                        slot="reference"
                        :disabled="
                          !$atividades.permissoes.includes(5) || blockButton
                        "
                        class="mx-1"
                        color="#0f4084"
                        icon="reply"
                        size="small"
                      />
                    </el-popconfirm>
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="
                      nota.numero != 'SN' &&
                      nota.id_status == 1 &&
                      nota.hasError == 0
                    "
                    color="success"
                    text="Processar Nota"
                  >
                    <el-popconfirm
                      cancelButtonText="Cancelar"
                      confirmButtonText="Processar"
                      icon="el-icon-circle-check"
                      iconColor="#00BBA2"
                      title="Deseja processar esta nota?"
                      @confirm="consultarProtocolo(nota)"
                    >
                      <vs-button
                        slot="reference"
                        :disabled="
                          !$atividades.permissoes.includes(5) ||
                          nota.lixeira > 0 ||
                          blockButton
                        "
                        class="mx-1"
                        color="success"
                        icon="done"
                        size="small"
                      />
                    </el-popconfirm>
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="nota.id_status == 2"
                    color="warning"
                    text="Reenviar Email"
                  >
                    <el-popconfirm
                      cancelButtonText="Cancelar"
                      confirmButtonText="Reenviar"
                      icon="el-icon-circle-check"
                      iconColor="#0f4084"
                      title="Deseja reenviar os emails para o cliente?"
                      @confirm="reeeviarEmails(nota)"
                    >
                      <vs-button
                        slot="reference"
                        :disabled="
                          !$atividades.permissoes.includes(5) ||
                          nota.lixeira > 0 ||
                          blockButton
                        "
                        class="mx-1"
                        color="warning"
                        icon="mark_email_read"
                        size="small"
                      />
                    </el-popconfirm>
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="nota.id_status == 2"
                    color="success"
                    text="Visualizar Nota"
                  >
                    <vs-button
                      :disabled="
                        !$atividades.permissoes.includes(5) ||
                        nota.lixeira > 0 ||
                        blockButton
                      "
                      class="mx-1"
                      color="success"
                      icon="remove_red_eye"
                      size="small"
                      @click="redirectBlank(nota)"
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    v-else-if="nota.hasError == 1"
                    color="warning"
                    text="Reenviar RPS"
                  >
                    <vs-button
                      :disabled="
                        !$atividades.permissoes.includes(5) ||
                        nota.lixeira > 0 ||
                        blockButton
                      "
                      class="mx-1"
                      color="warning"
                      icon="send"
                      size="small"
                      @click="reenviarRps(nota)"
                    />
                  </vx-tooltip>
                </vs-row>
              </vs-list-item>
              <div class="list-border">
                <vs-row vs-align="center" vs-justify="space-between" vs-w="12">
                  <span class="mx-2">
                    RPS:
                    <strong>{{ nota.rps }}</strong>
                  </span>
                  <span class="mx-2">
                    Valor Bruto:
                    <strong>{{ $currency(nota.valor_bruto) }}</strong>
                  </span>
                  <span class="mx-2">
                    Valor Líquido:
                    <strong>{{ $currency(nota.valor_liquido) }}</strong>
                  </span>
                  <span class="mx-2">
                    Emissão:
                    <strong>
                      {{ nota.emissao ? nota.emissao : "Sem data" }}
                    </strong>
                  </span>
                </vs-row>
              </div>
              <vs-list-item
                :title="nota.obs ? nota.obs : 'Sem Observação'"
                class="mt-1 p-0 list"
                icon="error_outline"
              />
              <vs-list-item class="mt-1 p-0 list">
                <template slot="avatar">
                  <div class="list-titles">
                    <div class="vs-list--icon">
                      <vs-icon class="mx-1" icon="done_all"></vs-icon>
                      <div class="vs-list--title">
                        {{
                          nota.data_leitura_email
                            ? "Email - Lido em " +
                              $moment(nota.data_leitura_email).format(
                                "DD/MM/YYYY HH:mm"
                              )
                            : "Email - Não lido"
                        }}
                      </div>
                    </div>
                  </div>
                </template>
              </vs-list-item>
            </vs-list>
          </vx-card>
        </vs-row>
      </span>
    </div>
    <div v-else :id="'notaLista' + fatura.id" class="vs-con-loading__container">
      <div class="con-colors">
        <ul>
          <span
            class="pt-2"
            style="color: grey !important; font-weight: 1000 !important"
          >
            <vs-col
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
            >
              <vs-icon icon="sentiment_dissatisfied" size="large"></vs-icon>
            </vs-col>
            <vs-col
              class="mt-2"
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
            >
              <span>NÃO HÁ NOTAS</span>
            </vs-col>
          </span>
        </ul>
      </div>
    </div>
    <component
      v-bind:is="modalEditarNota"
      :key="reRenderModalEditarNota"
      :blockButton="0"
      :nota="notaSelected"
      @update="close()"
    />
    <component
      v-bind:is="modalVerErrosNota"
      :key="reRenderModalVerErrosNota"
      :json="null"
      :nota="notaSelected"
      titulo="Ver Erros Consulta de RPS"
      @update="close()"
    />
    <component
      v-bind:is="modalReenviarRps"
      :key="reRenderModalReenviarRps"
      :contrato="contrato"
      :fatura="fatura"
      :nota="notaSelected"
      @update="close()"
    />
  </div>
</template>
<script>
import components from "@/components/default/exports.js";
import EditarNota from "./components/editNota";
import verErros from "./components/verErros";
import ReenviarRps from "./components/reenviarRps";

export default {
  props: {
    fatura: null,
    empresa: null,
    cliente: null,
    contrato: null,
  },
  data() {
    return {
      notas: [],
      confScroll: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      blockButton: false,
      notaSelected: {},
      modalEditarNota: "",
      modalVerErrosNota: "",
      modalReenviarRps: "",
      reRenderModalEditarNota: 0,
      reRenderModalVerErrosNota: 0,
      reRenderModalReenviarRps: 0,
    };
  },
  methods: {
    async verErros(nota) {
      this.notaSelected = nota;
      this.modalVerErrosNota = "verErros";
      this.reRenderModalVerErrosNota += 1;
    },
    async getNotasByFatura() {
      try {
        this.notas = await this.$http.get(
          `getContasByFatura/` + this.fatura.id
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async editarNota(nota) {
      this.notaSelected = nota;
      this.modalEditarNota = "EditarNota";
      this.reRenderModalEditarNota += 1;
    },
    async restaurarNota(nota) {
      this.blockButton = true;
      await this.$vs.loading({
        container: "#notaLista" + this.fatura.id,
        scale: 0.6,
      });
      try {
        await this.$http.post(`changeNotaContaStatus/` + nota.id, {
          id_status: 1,
          lixeira: 0,
        });
        this.faturamento = this.$http.put("faturamento/" + this.fatura.id, {
          data_faturamento: nota.data_emissao,
          id_status: 3,
        });
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Restauração da Nota N°" + nota.id,
        };
        await this.$logger(logData);
        this.$vs.notify({
          title: "Nota restaurada com sucesso!",
          color: "success",
        });
        this.$emit("update");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.close();
        this.blockButton = false;
        await this.$vs.loading.close(
          "#notaLista" + this.fatura.id + " > .con-vs-loading"
        );
      }
    },
    async cancelarNota(nota) {
      this.blockButton = true;
      await this.$vs.loading({
        container: "#notaLista" + this.fatura.id,
        scale: 0.6,
      });
      try {
        await this.$http.post(`changeNotaContaStatus/` + nota.id, {
          lixeira: 1,
        });
        this.faturamento = this.$http.put("faturamento/" + this.fatura.id, {
          data_faturamento: null,
          id_status: 1,
        });
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Cancelamento da Nota N°" + nota.id,
        };
        await this.$logger(logData);
        this.$vs.notify({
          title: "Nota cancelada com sucesso!",
          color: "success",
        });
        this.$emit("update");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.close();
        this.blockButton = false;
        await this.$vs.loading.close(
          "#notaLista" + this.fatura.id + " > .con-vs-loading"
        );
      }
    },
    async reenviarRps(nota) {
      this.notaSelected = nota;
      this.modalReenviarRps = "ReenviarRps";
      this.reRenderModalReenviarRps += 1;
    },
    async consultarProtocolo(nota) {
      this.blockButton = true;
      await this.$vs.loading({
        container: "#notaLista" + this.fatura.id,
        scale: 0.6,
      });
      try {
        const objNota = await this.objConsultarProtocolo(nota);
        await this.$http.post("consultarProtocolo", {
          data: objNota,
          id_nota: nota.id,
          rps: nota.rps,
        });
        this.$vs.notify({
          title: "Consulta realizada!",
          text: "Verifique se há erros na consulta!",
          color: "success",
        });
        this.$emit("update");
      } catch (err) {
        if (err.response != undefined) {
          this.$vs.notify({
            title: "Erros na consulta do RPS e da Nota!",
            text: "Verifique os erros na consulta e tente novamente!",
            color: "danger",
          });
        } else {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
          if (error.code == 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
        }
      } finally {
        await this.close();
        this.blockButton = false;
        await this.$vs.loading.close(
          "#notaLista" + this.fatura.id + " > .con-vs-loading"
        );
      }
    },
    async redirectBlank(nota) {
      const link = nota.link;
      var a = document.createElement("a");
      a.target = "_blank";
      a.href = link;
      a.click();
    },
    async objConsultarProtocolo(nota) {
      let obj = {
        identificacaoRps: {
          ambiente: process.env.NODE_ENV,
          passphrase: "1234",
          protocolo: nota.protocolo,
        },
        prestador: {
          cnpjPrestador: await this.$removerMascara.remove(
            `${this.empresa.cnpj}`
          ),
          ccmPrestador: await this.$removerMascara.remove(
            `${this.empresa.inscricao_municipal}`
          ),
        },
      };
      return obj;
    },
    async reeeviarEmails(nota) {
      await this.$vs.loading({
        container: "#notaLista" + this.fatura.id,
        scale: 0.6,
      });
      try {
        await this.$http.post(`reenviarEmailNota`, nota);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Reenvio dos email da Nota N°" + nota.id,
        };
        await this.$logger(logData);
        this.$vs.notify({
          title: "Emails reenviados com sucesso!",
          color: "success",
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close(
          "#notaLista" + this.fatura.id + " > .con-vs-loading"
        );
      }
    },
    async close() {
      this.$emit("update");
    },
  },
  async mounted() {
    await this.$vs.loading({
      container: "#notaLista" + this.fatura.id,
      scale: 0.6,
    });
    await this.getNotasByFatura();
    await this.$vs.loading.close(
      "#notaLista" + this.fatura.id + " > .con-vs-loading"
    );
  },
  components: { ...components, EditarNota, verErros, ReenviarRps },
};
</script>
<style lang="scss" scoped>
#lista * {
  font-size: 15px !important;
}

.border {
  box-shadow: none !important;
  border-radius: 5px !important;
}

.list-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 5px;
}

.scroll-notas {
  height: 20vh !important;
}

.el-popconfirm__main {
  font-size: 12px !important;
}
</style>
